import { motion } from "framer-motion";

const stats = [
  { big: "50", accent: "states", note: "Nationwide coverage" },
  { big: "$39", accent: "", note: "Flat fee to start" },
  { big: "0", accent: "lawyers", note: "Required to file or win" },
];

export const StoryStats = () => (
  <section className="py-16 sm:py-24">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        data-testid="stats-black-card"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="bg-[#111827] rounded-[2rem] sm:rounded-[2.5rem] p-8 sm:p-12 lg:p-16 shadow-[0_40px_80px_-30px_rgba(10,10,10,0.45)]"
      >
        <div className="flex items-start gap-3 mb-10 sm:mb-14">
          <span className="w-2.5 h-2.5 bg-[#60A5FA] rotate-45 mt-1.5 shrink-0" />
          <p className="text-xs sm:text-sm font-bold tracking-[0.3em] uppercase text-[#a1a1aa] leading-relaxed">
            For regular people &amp;<br className="sm:hidden" /> small
            businesses
          </p>
        </div>

        <div>
          {stats.map((s, i) => (
            <motion.div
              key={s.note}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className={`flex flex-wrap items-baseline gap-x-6 gap-y-1 py-8 sm:py-10 ${
                i > 0 ? "border-t border-[#27272A]" : ""
              }`}
            >
              <div className="flex items-baseline gap-3 min-w-[220px]">
                <span className="font-display font-semibold text-6xl sm:text-7xl lg:text-8xl text-[#60A5FA] leading-none">
                  {s.big}
                </span>
                {s.accent && (
                  <span className="font-display font-semibold text-2xl sm:text-3xl text-[#60A5FA] lowercase">
                    {s.accent}
                  </span>
                )}
              </div>
              <span className="text-lg sm:text-xl text-[#a1a1aa]">
                {s.note}
              </span>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
